import { render, staticRenderFns } from "./formulator-slider-additive.vue?vue&type=template&id=fb4be57e&"
import script from "./formulator-slider-additive.vue?vue&type=script&lang=js&"
export * from "./formulator-slider-additive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports